import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "piechart.icon",
  "use": "piechart.icon-usage",
  "viewBox": "-9936.889 -16135.889 20.777 20.778",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-9936.889 -16135.889 20.777 20.778\" id=\"piechart.icon\"><defs><style>#piechart.icon .cls-1{fill:#ffa254}</style></defs><g id=\"piechart.icon_Group_406\" data-name=\"Group 406\" transform=\"translate(-10031 -16412)\"><path id=\"piechart.icon_Subtraction_70\" data-name=\"Subtraction 70\" class=\"cls-1\" d=\"M9.535,9.535H0A9.527,9.527,0,0,1,9.535,0V9.535Z\" transform=\"translate(94.111 276.111)\" /><path id=\"piechart.icon_Subtraction_69\" data-name=\"Subtraction 69\" class=\"cls-1\" d=\"M9.535,19.071A9.528,9.528,0,0,1,0,9.535H9.535V0a9.538,9.538,0,0,1,3.712,18.322A9.475,9.475,0,0,1,9.535,19.071Z\" transform=\"translate(95.817 277.818)\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/piechart.icon.svg
// module id = QdvL
// module chunks = 13